import { AspectMap } from "./aspects";

export interface Book extends AspectMap {
  id: string;
  label: string;
  location?: string;

  contaminated?: boolean;
  mastered?: boolean;
  language?: string;
  mastering: { id: string; level: number };
  reading: { id: string; level: number };
}

export function GetBookById(id: string, books = Books): Book | undefined {
  return books.find((b) => b.id == id);
}

export function FindBooksThatSpawnId(spawnId: string, books = Books): Book[] {
  return books.filter(
    (b) => b.mastering.id == spawnId || b.reading.id == spawnId,
  );
}

export function spawnsNumen(book: Book): boolean {
  return book.reading.id.startsWith("numen.");
}

export function FindBooksThatSpawnNumen(books = Books): Book[] {
  return books.filter(spawnsNumen);
}

export const Books = [
  {
    lantern: 10,
    "period.dawn": 1,
    "w.cracktrack": 1,
    "cost.tally": 8,
    "r.watchmansparadoxes": 1,
    soph: 10,
    tablet: 1,
    mastering: { id: "s.watchmansparadoxes", level: 2 },
    reading: { id: "numen.asce", level: 1 },
    id: "t.thesunsdesign",
    label: "The Sun's Design",
    inherits: "_book",
    language: "s.cracktrack",
  },
  {
    grail: 10,
    "period.dawn": 1,
    "w.cracktrack": 1,
    "cost.tally": 8,
    "r.applebrighteuphonies": 1,
    soph: 10,
    scroll: 1,
    mastering: { id: "s.applebrighteuphonies", level: 2 },
    reading: { id: "numen.desc", level: 1 },
    id: "t.thesundisfigured",
    label: "The Sun Disfigured",
    inherits: "_book",
    language: "s.cracktrack",
  },
  {
    knock: 10,
    "period.curia": 1,
    "w.ericapaean": 1,
    "cost.tally": 8,
    "r.glassblowing.vesselcrafting": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.glassblowing.vesselcrafting", level: 2 },
    reading: { id: "numen.conf", level: 1 },
    id: "t.towardsafundamentalaesthetic",
    label: "Towards a Fundamental Aesthetic",
    inherits: "_book",
    language: "s.ericapaean",
  },
  {
    winter: 10,
    "period.nocturnal": 1,
    "w.ericapaean": 1,
    "cost.tally": 8,
    "r.sights.sensations": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.sights.sensations", level: 2 },
    reading: { id: "numen.unde", level: 1 },
    id: "t.towardsafundamentalaestheticsecondedition",
    label: "Towards a Fundamental Aesthetic: Second Edition",
    inherits: "_book",
    language: "s.ericapaean",
  },
  {
    nectar: 10,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 8,
    "r.spices.savours": 1,
    soph: 10,
    mastering: { id: "s.spices.savours", level: 2 },
    reading: { id: "numen.feas", level: 1 },
    id: "t.thewritingonthewall",
    label: "The Writing on the Wall",
    inherits: "_book",
    language: "s.vak",
  },
  {
    edge: 10,
    "period.baronial": 1,
    "w.hyksos": 1,
    "cost.tally": 8,
    "r.sharps": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.sharps", level: 2 },
    reading: { id: "numen.alte", level: 1 },
    id: "t.achildstreasuryofgoldenafternoons",
    label: "A Child's Treasury of Golden Afternoons",
    inherits: "_book",
    language: "s.hyksos",
  },
  {
    moth: 10,
    "period.dawn": 1,
    "w.killasimi": 1,
    "cost.tally": 8,
    "r.weaving.knotworking": 1,
    soph: 10,
    tablet: 1,
    mastering: { id: "s.weaving.knotworking", level: 2 },
    reading: { id: "numen.worl", level: 1 },
    id: "t.kopralithomphalos",
    label: "Kopralith Omphalos",
    inherits: "_book",
    language: "s.killasimi",
  },
  {
    rose: 10,
    "period.solar": 1,
    "w.ramsund": 1,
    "cost.tally": 8,
    "r.pentiments.precursors": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.pentiments.precursors", level: 2 },
    reading: { id: "numen.oldl", level: 1 },
    id: "t.theturquoisehand",
    label: "The Turquoise Hand",
    inherits: "_book",
    language: "s.ramsund",
  },
  {
    edge: 10,
    "period.dawn": 1,
    "w.sabazine": 1,
    "cost.tally": 8,
    "r.sickle.eclipse": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.sickle.eclipse", level: 2 },
    reading: { id: "numen.bala", level: 1 },
    id: "t.theskyinthescar",
    label: "The Sky in the Scar",
    inherits: "_book",
    language: "s.sabazine",
  },
  {
    sky: 10,
    "period.dawn": 1,
    "w.mandaic": 1,
    "cost.tally": 8,
    "r.sacrasolisinvicti": 1,
    soph: 10,
    scroll: 1,
    mastering: { id: "s.sacrasolisinvicti", level: 2 },
    reading: { id: "numen.secr", level: 1 },
    id: "t.shuriticbookofsuns",
    label: "Shuritic Book of Suns",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    forge: 10,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 8,
    "r.bells.brazieries": 1,
    soph: 10,
    tablet: 1,
    mastering: { id: "s.bells.brazieries", level: 2 },
    reading: { id: "numen.bell", level: 1 },
    id: "t.amiranisbeteli",
    label: "Amiranis Beteli",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    nectar: 10,
    "period.dawn": 1,
    "w.cracktrack": 1,
    "cost.tally": 8,
    "r.rites.theroots": 1,
    soph: 10,
    tablet: 1,
    mastering: { id: "s.rites.theroots", level: 2 },
    reading: { id: "numen.loop", level: 1 },
    id: "t.serpentroot",
    label: "Serpent-Root",
    inherits: "_book",
    language: "s.cracktrack",
  },
  {
    moon: 18,
    "period.solar": 1,
    "cost.tally": 8,
    "r.edictsinviolable": 1,
    soph: 18,
    codex: 1,
    mastering: { id: "s.edictsinviolable", level: 3 },
    reading: { id: "numen.thre", level: 1 },
    id: "t.thethreeandthethreestchiavimanuscript",
    label: "The Three and the Three (St Chiavi Manuscript)",
    inherits: "_book",
  },
  {
    sky: 4,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.watchmansparadoxes": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.watchmansparadoxes", level: 1 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.thelocksmithsdreamstolenreflections",
    label: "The Locksmith's Dream: Stolen Reflections",
    inherits: "_book",
  },
  {
    lantern: 6,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.glaziery.lightsmithing": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.glaziery.lightsmithing", level: 1 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.thelocksmithsdreamincursus",
    label: "The Locksmith's Dream: Incursus",
    inherits: "_book",
  },
  {
    sky: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.ouranoscopy": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.ouranoscopy", level: 1 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.thefallencross",
    label: "The Fallen Cross",
    inherits: "_book",
  },
  {
    moth: 6,
    "period.curia": 1,
    "cost.tally": 2,
    "r.resurgences.emergences": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.resurgences.emergences", level: 1 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.kitlingripeandthemoldywarpsgraveandotherstories",
    label: "Kitling Ripe and the Moldywarp's Grave (and Other Stories)",
    inherits: "_book",
  },
  {
    heart: 8,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.drums.dances": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.drums.dances", level: 2 },
    reading: { id: "earthsign", level: 1 },
    id: "t.raptintheking",
    label: "Rapt in the King",
    inherits: "_book",
  },
  {
    moon: 4,
    "period.curia": 1,
    "cost.tally": 2,
    "r.wolfstories": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.wolfstories", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.thevienneseconundra",
    label: "The Viennese Conundra",
    inherits: "_book",
  },
  {
    moon: 4,
    "period.curia": 1,
    "cost.tally": 2,
    "r.sickle.eclipse": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.sickle.eclipse", level: 1 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.collectedhushhouselectures",
    label: "Collected Hush House Lectures",
    inherits: "_book",
  },
  {
    moth: 10,
    "period.curia": 1,
    "cost.tally": 2,
    "r.solutions.separations": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.solutions.separations", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.thedebateofsevencups",
    label: "The Debate of Seven Cups",
    inherits: "_book",
  },
  {
    forge: 10,
    "period.curia": 1,
    "cost.tally": 2,
    "r.door.wall": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.door.wall", level: 2 },
    reading: { id: "secret.threshold", level: 1 },
    id: "t.thetemptationsofarchitecture",
    label: "The Temptations of Architecture",
    inherits: "_book",
  },
  {
    grail: 4,
    "period.solar": 1,
    "w.henavek": 1,
    "cost.tally": 4,
    "r.tridesmahiera": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.tridesmahiera", level: 1 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.thetripledheart",
    label: "The Tripled Heart",
    inherits: "_book",
    language: "s.henavek",
  },
  {
    winter: 6,
    "period.curia": 1,
    "cost.tally": 2,
    "r.rhyme.remembrance": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.rhyme.remembrance", level: 1 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.thefivelettersonmemory",
    label: "The Five Letters On Memory",
    inherits: "_book",
  },
  {
    moon: 4,
    "period.curia": 1,
    "cost.tally": 2,
    "r.putrefactions.calcinations": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.putrefactions.calcinations", level: 1 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.thetwelvelettersonconsequence",
    label: "The Twelve Letters On Consequence",
    inherits: "_book",
  },
  {
    lantern: 6,
    "period.solar": 1,
    "cost.tally": 4,
    "r.sacrasolisinvicti": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.sacrasolisinvicti", level: 1 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.gospelofnicodemus",
    label: "Gospel of Nicodemus",
    inherits: "_book",
  },
  {
    knock: 10,
    "period.curia": 1,
    "cost.tally": 2,
    "r.edictsliminal": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.edictsliminal", level: 2 },
    reading: { id: "secret.threshold", level: 1 },
    id: "t.analmanacofentrances",
    label: "An Almanac of Entrances",
    inherits: "_book",
  },
  {
    rose: 6,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.preliminalmeter": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.preliminalmeter", level: 1 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.justverse",
    label: "Just Verse",
    inherits: "_book",
  },
  {
    forge: 6,
    "period.curia": 1,
    "cost.tally": 2,
    "r.pyroglyphics": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.pyroglyphics", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.thebookofcinders",
    label: "The Book of Cinders",
    inherits: "_book",
  },
  {
    moon: 10,
    "period.curia": 1,
    "w.latin": 1,
    "cost.tally": 2,
    "r.snowstories": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.snowstories", level: 2 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.codexacephali",
    label: "Codex Acephali",
    inherits: "_book",
  },
  {
    rose: 14,
    "period.solar": 1,
    "cost.tally": 4,
    "r.inks.power": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.inks.power", level: 2 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.thehistoryofinks",
    label: "The History of Inks",
    inherits: "_book",
  },
  {
    lantern: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.anbary.lapidary": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.anbary.lapidary", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.inthemalleary",
    label: "In the Malleary",
    inherits: "_book",
  },
  {
    moon: 6,
    "period.curia": 1,
    "cost.tally": 2,
    "r.seastories": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.seastories", level: 1 },
    reading: { id: "mem.gossip", level: 1 },
    id: "t.thekerishamportolan",
    label: "The Kerisham Portolan",
    inherits: "_book",
  },
  {
    moon: 16,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 5,
    "r.wolfstories": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.wolfstories", level: 3 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.nixabolix",
    label: "Nix Abolix",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    knock: 12,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.thegreatsignsandthegreatscars": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.thegreatsignsandthegreatscars", level: 2 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.oghkoroghkortissilakoghkor",
    label: "OGHKOR OGHKOR TISSILAK OGHKOR",
    inherits: "_book",
  },
  {
    rose: 10,
    "period.curia": 1,
    "cost.tally": 2,
    "r.preliminalmeter": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.preliminalmeter", level: 2 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.theradicalmeasure",
    label: "The Radical Measure",
    inherits: "_book",
  },
  {
    rose: 12,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.preliminalmeter": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.preliminalmeter", level: 2 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.theradicalmeasureglossed",
    label: "The Radical Measure (Glossed)",
    inherits: "_book",
  },
  {
    rose: 10,
    "period.dawn": 1,
    "w.hyksos": 1,
    "cost.tally": 5,
    "r.sandstories": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.sandstories", level: 2 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.bookofmiah",
    label: "Book of Miah",
    inherits: "_book",
    language: "s.hyksos",
  },
  {
    grail: 8,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.desires.dissolutions": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.desires.dissolutions", level: 2 },
    reading: { id: "music.beguiling", level: 1 },
    id: "t.theintimationsofskin",
    label: "The Intimations of Skin",
    inherits: "_book",
  },
  {
    nectar: 8,
    "period.curia": 1,
    "w.killasimi": 1,
    "cost.tally": 2,
    "r.leaves.thorns": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.leaves.thorns", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.theberrybook",
    label: "The Berrybook",
    inherits: "_book",
    language: "s.killasimi",
  },
  {
    edge: 10,
    "period.curia": 1,
    "cost.tally": 2,
    "r.disciplines.thehammer": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.disciplines.thehammer", level: 2 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.sevenshards",
    label: "Seven Shards",
    inherits: "_book",
  },
  {
    moon: 8,
    "period.curia": 1,
    "w.latin": 1,
    "cost.tally": 2,
    "r.seastories": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.seastories", level: 2 },
    reading: { id: "mem.salt", level: 1 },
    id: "t.thecrossingtonoon",
    label: "The Crossing to Noon",
    inherits: "_book",
  },
  {
    moon: 4,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.edictsinviolable": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.edictsinviolable", level: 1 },
    reading: { id: "mem.storm", level: 1 },
    id: "t.whatdoesnotbark",
    label: "What Does Not Bark",
    inherits: "_book",
  },
  {
    scale: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.coil.chasm": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.coil.chasm", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.stolenhistories",
    label: "Stolen Histories",
    inherits: "_book",
  },
  {
    moon: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.wolfstories": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.wolfstories", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.blacknephrite",
    label: "Black Nephrite",
    inherits: "_book",
  },
  {
    moon: 6,
    "period.curia": 1,
    "cost.tally": 2,
    "r.pearl.tide": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.pearl.tide", level: 1 },
    reading: { id: "mem.salt", level: 1 },
    id: "t.theseadoesnotregret",
    label: "The Sea Does Not Regret",
    inherits: "_book",
  },
  {
    heart: 8,
    "period.curia": 1,
    "w.killasimi": 1,
    "cost.tally": 2,
    "r.stitching.binding": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.stitching.binding", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.twowombsoneheart",
    label: "Two Wombs, One Heart",
    inherits: "_book",
    language: "s.killasimi",
  },
  {
    scale: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.pentiments.precursors": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.pentiments.precursors", level: 1 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.onehundredandeight",
    label: "One Hundred And Eight",
    inherits: "_book",
  },
  {
    moon: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.maggephenemysteries": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.maggephenemysteries", level: 1 },
    reading: { id: "mem.solace", level: 1 },
    id: "t.theworlddespoild",
    label: "The World Despoil'd",
    inherits: "_book",
  },
  {
    grail: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.leaves.thorns": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.leaves.thorns", level: 1 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.animpertinentvitulation",
    label: "An Impertinent Vitulation",
    inherits: "_book",
  },
  {
    knock: 8,
    "period.solar": 1,
    "w.latin": 1,
    "cost.tally": 4,
    "r.thegreatsignsandthegreatscars": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.thegreatsignsandthegreatscars", level: 2 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.cardeasdelights",
    label: "Cardea's Delights",
    inherits: "_book",
  },
  {
    knock: 6,
    "period.solar": 1,
    "w.latin": 1,
    "cost.tally": 4,
    "r.thegreatsignsandthegreatscars": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.thegreatsignsandthegreatscars", level: 1 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.theelationsoflimentinus",
    label: "The Elations of Limentinus",
    inherits: "_book",
  },
  {
    knock: 4,
    "period.solar": 1,
    "w.latin": 1,
    "cost.tally": 4,
    "r.thegreatsignsandthegreatscars": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.thegreatsignsandthegreatscars", level: 1 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.therapturesofforculus",
    label: "The Raptures of Forculus",
    inherits: "_book",
  },
  {
    grail: 8,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.applebrighteuphonies": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.applebrighteuphonies", level: 2 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.snareofthetreecollectedproverbsofauntmopsy",
    label: "Snare of the Tree: Collected Proverbs of Aunt Mopsy",
    inherits: "_book",
  },
  {
    nectar: 8,
    "period.curia": 1,
    "w.latin": 1,
    "cost.tally": 2,
    "r.rites.theroots": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.rites.theroots", level: 2 },
    reading: { id: "earthsign", level: 1 },
    id: "t.deratioquercuum",
    label: "De Ratio Quercuum",
    inherits: "_book",
  },
  {
    lantern: 14,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.pyroglyphics": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.pyroglyphics", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.opusmagnuscaeruleus",
    label: "Opus Magnum Caeruleum",
    inherits: "_book",
  },
  {
    lantern: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.auroralcontemplations": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.auroralcontemplations", level: 1 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.sunriseawakenings",
    label: "Sunrise Awakenings",
    inherits: "_book",
  },
  {
    nectar: 4,
    "period.baronial": 1,
    "w.latin": 1,
    "cost.tally": 3,
    "r.rites.theroots": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.rites.theroots", level: 1 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.dehorisbook1",
    label: "De Horis book 1",
    inherits: "_book",
  },
  {
    edge: 4,
    "period.baronial": 1,
    "w.latin": 1,
    "cost.tally": 3,
    "r.disciplines.thehammer": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.disciplines.thehammer", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.dehorisbook2",
    label: "De Horis book 2",
    inherits: "_book",
  },
  {
    edge: 4,
    "period.baronial": 1,
    "w.latin": 1,
    "cost.tally": 3,
    "r.disciplines.thescar": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.disciplines.thescar", level: 1 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.dehorisbook3",
    label: "De Horis book 3",
    inherits: "_book",
  },
  {
    knock: 4,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.edictsliminal": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.edictsliminal", level: 1 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.travellingatnightvol1",
    label: "Travelling at Night, vol 1",
    inherits: "_book",
  },
  {
    sky: 6,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.sights.sensations": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.sights.sensations", level: 1 },
    reading: { id: "mem.solace", level: 1 },
    id: "t.travellingatnightvol2",
    label: "Travelling at Night, vol 2",
    inherits: "_book",
  },
  {
    knock: 4,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.door.wall": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.door.wall", level: 1 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.travellingatnightvol3",
    label: "Travelling at Night, vol 3",
    inherits: "_book",
  },
  {
    lantern: 4,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.purifications.exaltations": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.purifications.exaltations", level: 1 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.thelocksmithsdreamalightthroughthekeyhole",
    label: "The Locksmith's Dream: a Light through the Keyhole",
    inherits: "_book",
  },
  {
    sky: 4,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.lockworks.clockworks": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.lockworks.clockworks", level: 1 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.thelocksmithsdreamportionsandproportions",
    label: "The Locksmith's Dream: Portions and Proportions",
    inherits: "_book",
  },
  {
    knock: 6,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.edictsliminal": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.edictsliminal", level: 1 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.thelocksmithsdreamtrespasses",
    label: "The Locksmith's Dream: Trespasses",
    inherits: "_book",
  },
  {
    moth: 4,
    "period.curia": 1,
    "cost.tally": 2,
    "r.transformations.liberations": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.transformations.liberations", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.thesixlettersonnecessity",
    label: "The Six Letters on Necessity",
    inherits: "_book",
  },
  {
    edge: 4,
    "period.curia": 1,
    "cost.tally": 2,
    "r.sharps": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.sharps", level: 1 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.thevictoryofcrowns",
    label: "The Victory of Crowns",
    inherits: "_book",
  },
  {
    winter: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.snowstories": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.snowstories", level: 1 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.anintroductiontohistories",
    label: "An Introduction to Histories",
    inherits: "_book",
  },
  {
    winter: 6,
    "period.curia": 1,
    "cost.tally": 2,
    "r.quenchings.quellings": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.quenchings.quellings", level: 1 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.onthewhite",
    label: "On the White",
    inherits: "_book",
  },
  {
    sky: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.skystories": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.skystories", level: 1 },
    reading: { id: "mem.gossip", level: 1 },
    id: "t.thehumoursofagentleman",
    label: "The Humours of a Gentleman",
    inherits: "_book",
  },
  {
    scale: 4,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.path.pilgrim": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.path.pilgrim", level: 1 },
    reading: { id: "mem.gossip", level: 1 },
    id: "t.thequeensoftherivers",
    label: "The Queens of the Rivers",
    inherits: "_book",
  },
  {
    heart: 4,
    "period.curia": 1,
    "cost.tally": 2,
    "r.surgeries.exsanguinations": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.surgeries.exsanguinations", level: 1 },
    reading: { id: "mem.storm", level: 1 },
    id: "t.apolloandmarsyas",
    label: "Apollo and Marsyas",
    inherits: "_book",
  },
  {
    grail: 4,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.resurgences.emergences": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.resurgences.emergences", level: 1 },
    reading: { id: "music.beguiling", level: 1 },
    id: "t.theskeletonsongs",
    label: "The Skeleton Songs",
    inherits: "_book",
  },
  {
    grail: 4,
    "period.baronial": 1,
    "w.latin": 1,
    "cost.tally": 3,
    "r.desires.dissolutions": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.desires.dissolutions", level: 1 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.theorchidtransfigurationsafeast",
    label: "The Orchid Transfigurations: a Feast",
    inherits: "_book",
  },
  {
    heart: 4,
    "period.curia": 1,
    "w.latin": 1,
    "cost.tally": 2,
    "r.maggephenemysteries": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.maggephenemysteries", level: 1 },
    reading: { id: "mem.solace", level: 1 },
    id: "t.theorchidtransfigurationsnoon",
    label: "The Orchid Transfigurations: Noon",
    inherits: "_book",
  },
  {
    grail: 8,
    "period.baronial": 1,
    "w.latin": 1,
    "cost.tally": 3,
    "r.resurgences.emergences": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.resurgences.emergences", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.theorchidtransfigurationsabirth",
    label: "The Orchid Transfigurations: a Birth",
    inherits: "_book",
  },
  {
    edge: 6,
    "period.curia": 1,
    "w.latin": 1,
    "cost.tally": 2,
    "r.disciplines.thescar": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.disciplines.thescar", level: 1 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.debellismurorum",
    label: "De Bellis Murorum",
    inherits: "_book",
  },
  {
    sky: 6,
    "period.baronial": 1,
    "w.greek": 1,
    "cost.tally": 3,
    "r.glassblowing.vesselcrafting": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.glassblowing.vesselcrafting", level: 1 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.onwhatiscontainedbysilver",
    label: "On What is Contained By Silver",
    inherits: "_book",
  },
  {
    heart: 4,
    "period.curia": 1,
    "w.greek": 1,
    "cost.tally": 2,
    "r.weaving.knotworking": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.weaving.knotworking", level: 1 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.atrueandcompleteaccountingoftheasclepianmysteriesoftherootsofthehouse",
    label:
      "A True and Complete Accounting of the Asclepian Mysteries of the Roots of the House",
    inherits: "_book",
  },
  {
    lantern: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.auroralcontemplations": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.auroralcontemplations", level: 1 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.wainscothistories",
    label: "Wainscot Histories",
    inherits: "_book",
  },
  {
    winter: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.snowstories": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.snowstories", level: 1 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.chioneatabydos",
    label: "Chione at Abydos",
    inherits: "_book",
  },
  {
    edge: 6,
    "period.baronial": 1,
    "w.latin": 1,
    "cost.tally": 3,
    "r.disciplines.thehammer": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.disciplines.thehammer", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.thehightraditionsofthenobleendeavour",
    label: "The High Traditions of the Noble Endeavour",
    inherits: "_book",
  },
  {
    grail: 10,
    "period.solar": 1,
    "w.greek": 1,
    "cost.tally": 4,
    "r.thegreatsignsandthegreatscars": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.thegreatsignsandthegreatscars", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.theroseofnuriel",
    label: "The Rose of Nuriel",
    inherits: "_book",
  },
  {
    moth: 8,
    "period.solar": 1,
    "w.greek": 1,
    "cost.tally": 4,
    "r.weaving.knotworking": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.weaving.knotworking", level: 2 },
    reading: { id: "mem.solace", level: 1 },
    id: "t.theroseofhypatia",
    label: "The Rose of Hypatia",
    inherits: "_book",
  },
  {
    lantern: 8,
    "period.baronial": 1,
    "w.greek": 1,
    "cost.tally": 3,
    "r.auroralcontemplations": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.auroralcontemplations", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.theroseofwaznei",
    label: "The Rose of Waznei",
    inherits: "_book",
  },
  {
    knock: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.horns.ivories": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.horns.ivories", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.thetreatiseonunderplaces",
    label: "The Treatise on Underplaces",
    inherits: "_book",
  },
  {
    edge: 4,
    "period.curia": 1,
    "cost.tally": 2,
    "r.meniscatereflections": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.meniscatereflections", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.thewaroftheroads14511551",
    label: "The War of the Roads, 1451-1551",
    inherits: "_book",
  },
  {
    forge: 4,
    "period.dawn": 1,
    "w.latin": 1,
    "cost.tally": 5,
    "r.sacrasolisinvicti": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.sacrasolisinvicti", level: 1 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.sunsetpassages",
    label: "Sunset Passages",
    inherits: "_book",
  },
  {
    knock: 8,
    "period.solar": 1,
    "w.greek": 1,
    "cost.tally": 4,
    "r.horns.ivories": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.horns.ivories", level: 2 },
    reading: { id: "mem.dreamt", level: 1 },
    id: "t.thegospelofzacchaeus",
    label: "The Gospel of Zacchaeus",
    inherits: "_book",
  },
  {
    moth: 6,
    "period.dawn": 1,
    "w.aramaic": 1,
    "cost.tally": 5,
    "r.solutions.separations": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.solutions.separations", level: 1 },
    reading: { id: "mem.dreamt", level: 1 },
    id: "t.onmatthiasandtheamethystimagoloss",
    label: "On Matthias and the Amethyst Imago: Loss",
    inherits: "_book",
  },
  {
    forge: 6,
    "period.dawn": 1,
    "w.aramaic": 1,
    "cost.tally": 5,
    "r.spices.savours": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.spices.savours", level: 1 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.onmatthiasandtheamethystimagotransformation",
    label: "On Matthias and the Amethyst Imago: Transformation",
    inherits: "_book",
  },
  {
    grail: 6,
    "period.dawn": 1,
    "w.aramaic": 1,
    "cost.tally": 5,
    "r.desires.dissolutions": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.desires.dissolutions", level: 1 },
    reading: { id: "mem.gossip", level: 1 },
    id: "t.onmatthiasandtheamethystimagopursuit",
    label: "On Matthias and the Amethyst Imago: Pursuit",
    inherits: "_book",
  },
  {
    lantern: 4,
    "period.curia": 1,
    "w.latin": 1,
    "cost.tally": 2,
    "r.pyroglyphics": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.pyroglyphics", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.bancroftdiaries",
    label: "Bancroft Diaries",
    inherits: "_book",
  },
  {
    winter: 6,
    "period.baronial": 1,
    "w.latin": 1,
    "cost.tally": 3,
    "r.raggedcrossroads": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.raggedcrossroads", level: 1 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.thoseindignitiesperpetratedbythedeceitfulfraternityofobliviates",
    label:
      "Those Indignities Perpetrated By the Deceitful Fraternity of Obliviates",
    inherits: "_book",
  },
  {
    grail: 6,
    "period.curia": 1,
    "w.sanskrit": 1,
    "cost.tally": 2,
    "r.applebrighteuphonies": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.applebrighteuphonies", level: 1 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.thedevouredtantra",
    label: "The Devoured Tantra",
    inherits: "_book",
  },
  {
    heart: 6,
    "period.curia": 1,
    "w.sanskrit": 1,
    "cost.tally": 2,
    "r.weaving.knotworking": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.weaving.knotworking", level: 1 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.theceaselesstantra",
    label: "The Ceaseless Tantra",
    inherits: "_book",
  },
  {
    lantern: 6,
    "period.curia": 1,
    "w.sanskrit": 1,
    "cost.tally": 2,
    "r.watchmansparadoxes": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.watchmansparadoxes", level: 1 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.theknownunknowntantra",
    label: "The Known-Unknown Tantra",
    inherits: "_book",
  },
  {
    scale: 6,
    "period.curia": 1,
    "w.sanskrit": 1,
    "cost.tally": 2,
    "r.horns.ivories": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.horns.ivories", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.theencirclingtantra",
    label: "The Encircling Tantra",
    inherits: "_book",
  },
  {
    moth: 6,
    "period.dawn": 1,
    "w.sanskrit": 1,
    "cost.tally": 5,
    "r.rites.theroots": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.rites.theroots", level: 1 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.theshavenlocktantra",
    label: "The Shaven Lock Tantra",
    inherits: "_book",
  },
  {
    scale: 8,
    "period.nocturnal": 1,
    "w.sanskrit": 1,
    "cost.tally": 1,
    "r.coil.chasm": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.coil.chasm", level: 2 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.thetantraofworms",
    label: "The Tantra of Worms",
    inherits: "_book",
  },
  {
    rose: 6,
    "period.curia": 1,
    "w.greek": 1,
    "cost.tally": 2,
    "r.sandstories": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.sandstories", level: 1 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.thebookofthecentipede",
    label: "The Book of the Centipede",
    inherits: "_book",
  },
  {
    moon: 6,
    "period.dawn": 1,
    "w.aramaic": 1,
    "cost.tally": 5,
    "r.sharps": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.sharps", level: 1 },
    reading: { id: "mem.dreamt", level: 1 },
    id: "t.theaccountofkanishkatthespidersdoor",
    label: "The Account of Kanishk at the Spider's Door",
    inherits: "_book",
  },
  {
    forge: 6,
    "period.dawn": 1,
    "w.phrygian": 1,
    "cost.tally": 5,
    "r.transformations.liberations": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.transformations.liberations", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.thevinzantinscriptions",
    label: "The Vinzant Inscriptions",
    inherits: "_book",
  },
  {
    moon: 6,
    "period.dawn": 1,
    "w.phrygian": 1,
    "cost.tally": 5,
    "r.seastories": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.seastories", level: 1 },
    reading: { id: "mem.salt", level: 1 },
    id: "t.thelarquebinecodex",
    label: "The Larquebine Codex",
    inherits: "_book",
  },
  {
    sky: 6,
    "period.curia": 1,
    "w.greek": 1,
    "cost.tally": 2,
    "r.skystories": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.skystories", level: 1 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.againstthesisterhoodoftheknotandthefoulnessoftheirdepravedcustoms",
    label:
      "Against the Sisterhood of the Knot and the Foulness of their Depraved Customs",
    inherits: "_book",
  },
  {
    moon: 6,
    "period.dawn": 1,
    "w.aramaic": 1,
    "cost.tally": 5,
    "r.tridesmahiera": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.tridesmahiera", level: 1 },
    reading: { id: "music.beguiling", level: 1 },
    id: "t.themorphycodex",
    label: "The Morphy Codex",
    inherits: "_book",
  },
  {
    edge: 8,
    "period.curia": 1,
    "w.sanskrit": 1,
    "cost.tally": 2,
    "r.edictsmartial": 1,
    soph: 8,
    scroll: 1,
    mastering: { id: "s.edictsmartial", level: 2 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.theleoninetantra",
    label: "The Leonine Tantra",
    inherits: "_book",
  },
  {
    forge: 8,
    "period.curia": 1,
    "w.sanskrit": 1,
    "cost.tally": 2,
    "r.transformations.liberations": 1,
    soph: 8,
    scroll: 1,
    mastering: { id: "s.transformations.liberations", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.theincandescenttantra",
    label: "The Incandescent Tantra",
    inherits: "_book",
  },
  {
    grail: 8,
    "period.curia": 1,
    "w.sanskrit": 1,
    "cost.tally": 2,
    "r.orchids.narcotics": 1,
    soph: 8,
    scroll: 1,
    mastering: { id: "s.orchids.narcotics", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.thethirstingtantra",
    label: "The Thirsting Tantra",
    inherits: "_book",
  },
  {
    heart: 8,
    "period.curia": 1,
    "w.sanskrit": 1,
    "cost.tally": 2,
    "r.maggephenemysteries": 1,
    soph: 8,
    scroll: 1,
    mastering: { id: "s.maggephenemysteries", level: 2 },
    reading: { id: "mem.storm", level: 1 },
    id: "t.theflayedtantra",
    label: "The Flayed Tantra",
    inherits: "_book",
  },
  {
    lantern: 8,
    "period.curia": 1,
    "w.sanskrit": 1,
    "cost.tally": 2,
    "r.purifications.exaltations": 1,
    soph: 8,
    scroll: 1,
    mastering: { id: "s.purifications.exaltations", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.thewatchfultantra",
    label: "The Watchful Tantra",
    inherits: "_book",
  },
  {
    knock: 8,
    "period.nocturnal": 1,
    "w.sanskrit": 1,
    "cost.tally": 1,
    "r.edictsliminal": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.edictsliminal", level: 2 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.thetwinserpenttantra",
    label: "The Twin-Serpent Tantra",
    inherits: "_book",
  },
  {
    moth: 8,
    "period.curia": 1,
    "w.sanskrit": 1,
    "cost.tally": 2,
    "r.solutions.separations": 1,
    soph: 8,
    scroll: 1,
    mastering: { id: "s.solutions.separations", level: 2 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.thefirecircletantra",
    label: "The Fire-Circle Tantra",
    inherits: "_book",
  },
  {
    edge: 8,
    "period.dawn": 1,
    "w.aramaic": 1,
    "cost.tally": 5,
    "r.sickle.eclipse": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.sickle.eclipse", level: 2 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.asthesunhiscourse",
    label: "As The Sun His Course",
    inherits: "_book",
  },
  {
    rose: 8,
    "period.dawn": 1,
    "w.phrygian": 1,
    "cost.tally": 5,
    "r.path.pilgrim": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.path.pilgrim", level: 2 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.theconcursumdiaries",
    label: "The Concursum Diaries",
    inherits: "_book",
  },
  {
    edge: 8,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 5,
    "r.disciplines.thehammer": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.disciplines.thehammer", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.theironbook",
    label: "The Iron Book",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    moth: 8,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 5,
    "r.edictsliminal": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.edictsliminal", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.thesilverbook",
    label: "The Silver Book",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    winter: 8,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 5,
    "r.quenchings.quellings": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.quenchings.quellings", level: 2 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.theivorybook",
    label: "The Ivory Book",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    heart: 10,
    "period.curia": 1,
    "w.fucine": 1,
    "cost.tally": 2,
    "r.weaving.knotworking": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.weaving.knotworking", level: 2 },
    reading: { id: "mem.solace", level: 1 },
    id: "t.thegeminiadi",
    label: "The Geminiad i",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    grail: 10,
    "period.curia": 1,
    "w.fucine": 1,
    "cost.tally": 2,
    "r.pentiments.precursors": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.pentiments.precursors", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.thegeminiadii",
    label: "The Geminiad ii",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    moth: 12,
    "period.curia": 1,
    "w.fucine": 1,
    "cost.tally": 2,
    "r.resurgences.emergences": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.resurgences.emergences", level: 2 },
    reading: { id: "music.beguiling", level: 1 },
    id: "t.thegeminiadiii",
    label: "The Geminiad iii",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    winter: 10,
    "period.solar": 1,
    "w.aramaic": 1,
    "cost.tally": 4,
    "r.putrefactions.calcinations": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.putrefactions.calcinations", level: 2 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.theworlddoesnotweep",
    label: "The World Does Not Weep",
    inherits: "_book",
  },
  {
    edge: 12,
    "period.solar": 1,
    "w.greek": 1,
    "cost.tally": 4,
    "r.sharps": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.sharps", level: 2 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.thedeedsofthescarredcaptain",
    label: "The Deeds of the Scarred Captain",
    inherits: "_book",
  },
  {
    forge: 12,
    "period.dawn": 1,
    "w.mandaic": 1,
    "cost.tally": 5,
    "r.transformations.liberations": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.transformations.liberations", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.thebookofdissolution",
    label: "The Book of Dissolution",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    grail: 12,
    "period.dawn": 1,
    "w.phrygian": 1,
    "cost.tally": 5,
    "r.orchids.narcotics": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.orchids.narcotics", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.acatalogueofunchartedpleasures",
    label: "A Catalogue of Uncharted Pleasures",
    inherits: "_book",
  },
  {
    heart: 12,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 5,
    "r.surgeries.exsanguinations": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.surgeries.exsanguinations", level: 2 },
    reading: { id: "mem.storm", level: 1 },
    id: "t.thosewhodonotsleep",
    label: "Those Who Do Not Sleep",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    lantern: 12,
    "period.dawn": 1,
    "w.aramaic": 1,
    "cost.tally": 5,
    "r.pyroglyphics": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.pyroglyphics", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.theskythesoul",
    label: "The Sky, the Soul",
    inherits: "_book",
  },
  {
    knock: 12,
    "period.curia": 1,
    "w.vak": 1,
    "cost.tally": 2,
    "r.edictsliminal": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.edictsliminal", level: 2 },
    reading: { id: "secret.threshold", level: 1 },
    id: "t.onthematterandthedeedsofserpents",
    label: "On the Matter and the Deeds of Serpents",
    inherits: "_book",
    language: "s.vak",
  },
  {
    moth: 12,
    "period.solar": 1,
    "w.greek": 1,
    "cost.tally": 4,
    "r.sacralimiae": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.sacralimiae", level: 2 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.theserenityoftheblackwood",
    label: "The Serenity of the Black Wood",
    inherits: "_book",
  },
  {
    edge: 12,
    "period.curia": 1,
    "w.phrygian": 1,
    "cost.tally": 2,
    "r.auroralcontemplations": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.auroralcontemplations", level: 2 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.thebookofthrones",
    label: "The Book of Thrones",
    inherits: "_book",
  },
  {
    winter: 12,
    "period.solar": 1,
    "w.mandaic": 1,
    "cost.tally": 4,
    "r.snowstories": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.snowstories", level: 2 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.asecondglory",
    label: "A Second Glory",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    edge: 14,
    "period.solar": 1,
    "w.latin": 1,
    "cost.tally": 4,
    "r.meniscatereflections": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.meniscatereflections", level: 2 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.bookoftrueblood",
    label: "Book of True Blood",
    inherits: "_book",
  },
  {
    forge: 14,
    "period.dawn": 1,
    "w.phrygian": 1,
    "cost.tally": 5,
    "r.transformations.liberations": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.transformations.liberations", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.theburningwoman",
    label: "The Burning Woman",
    inherits: "_book",
  },
  {
    grail: 14,
    "period.nocturnal": 1,
    "w.fucine": 1,
    "cost.tally": 1,
    "r.resurgences.emergences": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.resurgences.emergences", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.twentysixenticementsseventorments",
    label: "Twenty-Six Enticements, Seven Torments",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    rose: 14,
    "period.dawn": 1,
    "w.aramaic": 1,
    "cost.tally": 5,
    "r.sandstories": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.sandstories", level: 2 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.isaacofkarthshistoryoftheshadowlesskings",
    label: "Isaac of Karth's History of the Shadowless Kings",
    inherits: "_book",
  },
  {
    lantern: 14,
    "period.solar": 1,
    "w.fucine": 1,
    "cost.tally": 4,
    "r.sacrasolisinvicti": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.sacrasolisinvicti", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.thehighmysteriesoftheinnermostchamberofourchurchsolar",
    label: "The High Mysteries of the Innermost Chamber of our Church Solar",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    scale: 14,
    "period.solar": 1,
    "w.greek": 1,
    "cost.tally": 4,
    "r.horns.ivories": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.horns.ivories", level: 2 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.medusaslament",
    label: "Medusa's Lament",
    inherits: "_book",
  },
  {
    moth: 14,
    "period.dawn": 1,
    "w.phrygian": 1,
    "cost.tally": 5,
    "r.weaving.knotworking": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.weaving.knotworking", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.thebookofmasks",
    label: "The Book of Masks",
    inherits: "_book",
  },
  {
    sky: 18,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 5,
    "r.skystories": 1,
    soph: 18,
    codex: 1,
    mastering: { id: "s.skystories", level: 3 },
    reading: { id: "mem.gossip", level: 1 },
    id: "t.inthemountainsasupontheplaintheremaynotbeapathwherenonehaspassed",
    label:
      "In The Mountains As Upon The Plain There May Not Be A Path Where None Has Passed",
    inherits: "_book",
    language: "s.vak",
  },
  {
    winter: 12,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 5,
    "r.raggedcrossroads": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.raggedcrossroads", level: 2 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.inmemoryofgods",
    label: "In Memory of Gods",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    edge: 16,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 5,
    "r.disciplines.thescar": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.disciplines.thescar", level: 3 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.thesevenfoldslayingofthesevencoiled",
    label: "The Sevenfold Slaying of the Seven-Coiled",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    forge: 16,
    "period.solar": 1,
    "w.mandaic": 1,
    "cost.tally": 4,
    "r.transformations.liberations": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.transformations.liberations", level: 3 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.mydeedsmypowersmyachievementsandtheinjusticesperpetratedagainstme",
    label:
      "My Deeds, My Powers, My Achievements and the Injustices Perpetrated Against Me",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    grail: 16,
    "period.dawn": 1,
    "w.phrygian": 1,
    "cost.tally": 5,
    "r.thegreatsignsandthegreatscars": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.thegreatsignsandthegreatscars", level: 3 },
    reading: { id: "mem.gossip", level: 1 },
    id: "t.thedreamoftheconspiracyofthelowerskies",
    label: "The Dream of the Conspiracy of the Lower Skies",
    inherits: "_book",
  },
  {
    sky: 16,
    "period.dawn": 1,
    "w.phrygian": 1,
    "cost.tally": 5,
    "r.watchmansparadoxes": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.watchmansparadoxes", level: 3 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.thebookofthewhitecat",
    label: "The Book of the White Cat",
    inherits: "_book",
  },
  {
    sky: 12,
    "period.dawn": 1,
    "w.mandaic": 1,
    "cost.tally": 5,
    "r.glaziery.lightsmithing": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.glaziery.lightsmithing", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.thelionandtheglass",
    label: "The Lion and the Glass",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    sky: 14,
    "period.dawn": 1,
    "w.mandaic": 1,
    "cost.tally": 5,
    "r.glaziery.lightsmithing": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.glaziery.lightsmithing", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.eachflamehisfuel",
    label: "Each Flame His Fuel",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    sky: 16,
    "period.dawn": 1,
    "w.mandaic": 1,
    "cost.tally": 5,
    "r.glaziery.lightsmithing": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.glaziery.lightsmithing", level: 3 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.thefocusofamber",
    label: "The Focus of Amber",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    moth: 16,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 5,
    "r.edictsliminal": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.edictsliminal", level: 3 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.thesongsofthecarapacecross",
    label: "The Songs of the Carapace Cross",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    sky: 16,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 5,
    "r.sacralimiae": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.sacralimiae", level: 3 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.theoriginsofhours",
    label: "The Origins of Hours",
    inherits: "_book",
    language: "s.vak",
  },
  {
    rose: 16,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 5,
    "r.sandstories": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.sandstories", level: 3 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.wherehasshegone",
    label: "Where Has She Gone?",
    inherits: "_book",
    language: "s.vak",
  },
  {
    heart: 16,
    "period.dawn": 1,
    "w.mandaic": 1,
    "cost.tally": 5,
    "r.quenchings.quellings": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.quenchings.quellings", level: 3 },
    reading: { id: "bittersweet.certainty", level: 1 },
    id: "t.thebookoftheextinguishedheart",
    label: "The Book of the Extinguished Heart",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    edge: 14,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 5,
    "r.raggedcrossroads": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.raggedcrossroads", level: 2 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.howtheendwillbegin",
    label: "How the End will Begin",
    inherits: "_book",
    language: "s.vak",
  },
  {
    forge: 14,
    "period.curia": 1,
    "w.vak": 1,
    "cost.tally": 2,
    "r.anbary.lapidary": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.anbary.lapidary", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.themannerinwhichthealchemistwasspared",
    label: "The Manner in which the Alchemist was Spared",
    inherits: "_book",
    language: "s.vak",
  },
  {
    moth: 14,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 5,
    "r.resurgences.emergences": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.resurgences.emergences", level: 2 },
    reading: { id: "mem.gossip", level: 1 },
    id: "t.fivecreations",
    label: "Five Creations",
    inherits: "_book",
    language: "s.vak",
  },
  {
    heart: 14,
    "period.solar": 1,
    "w.mandaic": 1,
    "cost.tally": 4,
    "r.stitching.binding": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.stitching.binding", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.commandmentsforthepreservationofallthatexists",
    label: "Commandments For the Preservation of All That Exists",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    heart: 14,
    "period.dawn": 1,
    "w.mandaic": 1,
    "cost.tally": 5,
    "r.surgeries.exsanguinations": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.surgeries.exsanguinations", level: 2 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.thetimeofdivision",
    label: "The Time of Division",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    knock: 14,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 5,
    "r.door.wall": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.door.wall", level: 2 },
    reading: { id: "secret.threshold", level: 1 },
    id: "t.amanualfordeparture",
    label: "A Manual for Departure",
    inherits: "_book",
    language: "s.vak",
  },
  {
    moth: 14,
    "period.curia": 1,
    "w.phrygian": 1,
    "cost.tally": 2,
    "r.transformations.liberations": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.transformations.liberations", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.inaamkapigiginlupirgarkiecryppys",
    label: "Inaam, Kapigiginlupir, Garkie, Cryppys",
    inherits: "_book",
  },
  {
    moon: 18,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 5,
    "r.seastories": 1,
    soph: 18,
    codex: 1,
    mastering: { id: "s.seastories", level: 3 },
    reading: { id: "mem.salt", level: 1 },
    id: "t.thevoyagesofferninshunoforeol",
    label: "The Voyages of Ferninshun of Oreol",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    winter: 14,
    "period.dawn": 1,
    "w.fucine": 1,
    "cost.tally": 5,
    "r.quenchings.quellings": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.quenchings.quellings", level: 2 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.thescarinthesky",
    label: "The Scar in the Sky",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    sky: 8,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.preliminalmeter": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.preliminalmeter", level: 2 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.aseventhvoice",
    label: "A Seventh Voice",
    inherits: "_book",
  },
  {
    heart: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.preliminalmeter": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.preliminalmeter", level: 1 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.theotherline",
    label: "The Other Line",
    inherits: "_book",
  },
  {
    rose: 14,
    "period.curia": 1,
    "w.ericapaean": 1,
    "cost.tally": 2,
    "r.preliminalmeter": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.preliminalmeter", level: 2 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.anovelmethodforinvocation.contrition",
    label: "A Novel Method for Invocation & Contrition",
    inherits: "_book",
    language: "s.ericapaean",
  },
  {
    grail: 8,
    "period.solar": 1,
    "w.greek": 1,
    "cost.tally": 4,
    "r.tridesmahiera": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.tridesmahiera", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.calicitesupplications",
    label: "Calicite Supplications",
    inherits: "_book",
  },
  {
    scale: 8,
    "period.solar": 1,
    "w.greek": 1,
    "cost.tally": 4,
    "r.stonestories": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.stonestories", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.ascitesupplications",
    label: "Ascite Supplications",
    inherits: "_book",
  },
  {
    moon: 8,
    "period.solar": 1,
    "w.greek": 1,
    "cost.tally": 4,
    "r.tridesmahiera": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.tridesmahiera", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.malachitesupplications",
    label: "Malachite Supplications",
    inherits: "_book",
  },
  {
    edge: 4,
    "period.solar": 1,
    "cost.tally": 4,
    "r.raggedcrossroads": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.raggedcrossroads", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.thesunslament",
    label: "The Sun's Lament",
    inherits: "_book",
  },
  {
    grail: 4,
    "period.solar": 1,
    "cost.tally": 4,
    "r.applebrighteuphonies": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.applebrighteuphonies", level: 1 },
    reading: { id: "music.beguiling", level: 1 },
    id: "t.thewindsruin",
    label: "The Wind's Ruin",
    inherits: "_book",
  },
  {
    moon: 4,
    "period.solar": 1,
    "cost.tally": 4,
    "r.pearl.tide": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.pearl.tide", level: 1 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.themoonsegg",
    label: "The Moon's Egg",
    inherits: "_book",
  },
  {
    moon: 12,
    "period.solar": 1,
    "cost.tally": 4,
    "r.inks.containment": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.inks.containment", level: 2 },
    reading: { id: "bittersweet.certainty", level: 1 },
    id: "t.theblackbookofbrittany",
    label: "The Black Book of Brittany",
    inherits: "_book",
  },
  {
    winter: 10,
    "period.solar": 1,
    "cost.tally": 4,
    "r.raggedcrossroads": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.raggedcrossroads", level: 2 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.thewhitebookofbrittany",
    label: "The White Book of Brittany",
    inherits: "_book",
  },
  {
    rose: 12,
    "period.solar": 1,
    "cost.tally": 4,
    "r.inks.power": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.inks.power", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.theredbookofbrittany",
    label: "The Red Book of Brittany",
    inherits: "_book",
  },
  {
    sky: 12,
    "period.solar": 1,
    "cost.tally": 4,
    "r.sights.sensations": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.sights.sensations", level: 2 },
    reading: { id: "mem.solace", level: 1 },
    id: "t.themirrorofmelancthe",
    label: "The Mirror of Melancthe",
    inherits: "_book",
  },
  {
    forge: 14,
    "period.solar": 1,
    "cost.tally": 4,
    "r.purifications.exaltations": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.purifications.exaltations", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.adescentoftheshell",
    label: "A Descent of the Shell",
    inherits: "_book",
  },
  {
    sky: 6,
    "period.solar": 1,
    "cost.tally": 4,
    "r.lockworks.clockworks": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.lockworks.clockworks", level: 1 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.againstvitruvius",
    label: "Against Vitruvius",
    inherits: "_book",
  },
  {
    sky: 10,
    "period.curia": 1,
    "cost.tally": 2,
    "r.ouranoscopy": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.ouranoscopy", level: 2 },
    reading: { id: "mem.storm", level: 1 },
    id: "t.demotucorporumvetitorum",
    label: "De motu corporum vetitorum",
    inherits: "_book",
  },
  {
    heart: 10,
    "period.solar": 1,
    "cost.tally": 4,
    "r.drums.dances": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.drums.dances", level: 2 },
    reading: { id: "music.cheerful", level: 1 },
    id: "t.theinstrumentsoftheheart",
    label: "The Instruments of the Heart",
    inherits: "_book",
  },
  {
    sky: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.ouranoscopy": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.ouranoscopy", level: 1 },
    reading: { id: "mem.salt", level: 1 },
    id: "t.journalofthomasdewulf",
    label: "Journal of Thomas Dewulf",
    inherits: "_book",
  },
  {
    forge: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.door.wall": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.door.wall", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.journalofwalterdewulf",
    label: "Journal of Walter Dewulf",
    inherits: "_book",
  },
  {
    moon: 4,
    "period.curia": 1,
    "cost.tally": 2,
    "r.seastories": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.seastories", level: 1 },
    reading: { id: "mem.salt", level: 1 },
    id: "t.apaleladyandaprinceofwines",
    label: "A Pale Lady and a Prince of Wines",
    inherits: "_book",
  },
  {
    sky: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.furs.feathers": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.furs.feathers", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.atruehistoryofvalentinedewulf",
    label: "A True History of Valentine Dewulf",
    inherits: "_book",
  },
  {
    winter: 4,
    "period.solar": 1,
    "w.latin": 1,
    "cost.tally": 4,
    "r.inks.containment": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.inks.containment", level: 1 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.annalsofstbrandans",
    label: "Annals of St Brandan's",
    inherits: "_book",
  },
  {
    nectar: 4,
    "period.solar": 1,
    "w.henavek": 1,
    "cost.tally": 4,
    "r.herbs.infusions": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.herbs.infusions", level: 1 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.themostsorrowfulendoftheladynonna",
    label: "The Most Sorrowful End of the Lady Nonna",
    inherits: "_book",
    language: "s.henavek",
  },
  {
    nectar: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.leaves.thorns": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.leaves.thorns", level: 1 },
    reading: { id: "mem.gossip", level: 1 },
    id: "t.threeflowershaththetree",
    label: "Three Flowers Hath the Tree",
    inherits: "_book",
  },
  {
    nectar: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.coil.chasm": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.coil.chasm", level: 1 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.theshadowinthestair",
    label: "The Shadow in the Stair",
    inherits: "_book",
  },
  {
    nectar: 12,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.insects.nectars": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.insects.nectars", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.cucurbitprisonerrecords1927",
    label: "Cucurbit Prisoner Records 1927",
    inherits: "_book",
  },
  {
    scale: 12,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.hill.hollow": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.hill.hollow", level: 2 },
    reading: { id: "mem.salt", level: 1 },
    id: "t.cucurbitprisonerrecords1928",
    label: "Cucurbit Prisoner Records 1928",
    inherits: "_book",
  },
  {
    knock: 8,
    "period.curia": 1,
    "w.ramsund": 1,
    "cost.tally": 2,
    "r.door.wall": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.door.wall", level: 2 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.onthewindingstair",
    label: "On the Winding Stair",
    inherits: "_book",
    language: "s.ramsund",
  },
  {
    rose: 6,
    "period.baronial": 1,
    "w.phrygian": 1,
    "cost.tally": 3,
    "r.path.pilgrim": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.path.pilgrim", level: 1 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.lettersfromafugitive",
    label: "Letters from a Fugitive",
    inherits: "_book",
  },
  {
    sky: 4,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.strings.songs": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.strings.songs", level: 1 },
    reading: { id: "music.cheerful", level: 1 },
    id: "t.perugiandiaries",
    label: "Perugian Diaries",
    inherits: "_book",
  },
  {
    scale: 6,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.pentiments.precursors": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.pentiments.precursors", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.keyofnight",
    label: "Key of Night",
    inherits: "_book",
  },
  {
    sky: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.bells.brazieries": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.bells.brazieries", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.onresonance",
    label: "On Resonance",
    inherits: "_book",
  },
  {
    moon: 14,
    "period.dawn": 1,
    "w.greek": 1,
    "cost.tally": 5,
    "r.serpents.venoms": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.serpents.venoms", level: 2 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.enchiridiontragularis",
    label: "Enchiridion Tragularis",
    inherits: "_book",
  },
  {
    scale: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.serpents.venoms": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.serpents.venoms", level: 1 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.therepublicofteeth",
    label: "The Republic of Teeth",
    inherits: "_book",
  },
  {
    sky: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.furs.feathers": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.furs.feathers", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.sevenfacesoficarus",
    label: "Seven Faces of Icarus",
    inherits: "_book",
  },
  {
    grail: 10,
    "period.curia": 1,
    "cost.tally": 2,
    "r.resurgences.emergences": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.resurgences.emergences", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.onthirstliesivoriesandlovelies",
    label: "On Thirstlies, Ivories and Lovelies",
    inherits: "_book",
  },
  {
    knock: 6,
    "period.curia": 1,
    "cost.tally": 2,
    "r.surgeries.exsanguinations": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.surgeries.exsanguinations", level: 1 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.bytheirmarksshallyeknowthem",
    label: "By Their Marks Shall Ye Know them",
    inherits: "_book",
  },
  {
    winter: 6,
    "period.curia": 1,
    "cost.tally": 2,
    "r.inks.containment": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.inks.containment", level: 1 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.oblationsiniron",
    label: "Oblations in Iron",
    inherits: "_book",
  },
  {
    lantern: 8,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.watchmansparadoxes": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.watchmansparadoxes", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.propheciesofglory",
    label: "Prophecies of Glory",
    inherits: "_book",
  },
  {
    forge: 8,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.pyroglyphics": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.pyroglyphics", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.ashapeinsmoke",
    label: "A Shape in Smoke",
    inherits: "_book",
  },
  {
    lantern: 8,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.inks.revelation": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.inks.revelation", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.alightintheinkwell",
    label: "A Light in the Inkwell",
    inherits: "_book",
  },
  {
    scale: 8,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.inks.power": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.inks.power", level: 2 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.itiswritten",
    label: "It Is Written",
    inherits: "_book",
  },
  {
    winter: 8,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.inks.containment": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.inks.containment", level: 2 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.etteryafter",
    label: "Ettery After",
    inherits: "_book",
  },
  {
    sky: 12,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.strings.songs": 1,
    soph: 12,
    "record.phonograph": 1,
    mastering: { id: "s.strings.songs", level: 2 },
    reading: { id: "music.cheerful", level: 1 },
    id: "t.theinvisibleoperaunfinishedrecording",
    label: "The Invisible Opera (Unfinished Recording)",
    inherits: "_book",
  },
  {
    sky: 10,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.strings.songs": 1,
    soph: 10,
    "record.phonograph": 1,
    mastering: { id: "s.strings.songs", level: 2 },
    reading: { id: "music.cheerful", level: 1 },
    id: "t.openingthesky",
    label: "Opening the Sky",
    inherits: "_book",
  },
  {
    heart: 12,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.drums.dances": 1,
    soph: 12,
    "record.phonograph": 1,
    mastering: { id: "s.drums.dances", level: 2 },
    reading: { id: "music.beguiling", level: 1 },
    id: "t.lakefucinorecordings",
    label: "Lake Fucino Recordings",
    inherits: "_book",
  },
  {
    forge: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.bells.brazieries": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.bells.brazieries", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.vinzantsminglings",
    label: "Vinzant's Minglings",
    inherits: "_book",
  },
  {
    nectar: 6,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.insects.nectars": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.insects.nectars", level: 1 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.honeythecomprehensiveguide",
    label: "Honey: the Comprehensive Guide",
    inherits: "_book",
  },
  {
    nectar: 6,
    "period.baronial": 1,
    "w.aramaic": 1,
    "cost.tally": 3,
    "r.herbs.infusions": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.herbs.infusions", level: 1 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.fekrisherbary",
    label: "Fekri's Herbary",
    inherits: "_book",
  },
  {
    nectar: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.spices.savours": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.spices.savours", level: 1 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.kitlingripestastytreats",
    label: "Kitling Ripe's Tasty Treats",
    inherits: "_book",
  },
  {
    winter: 10,
    "period.baronial": 1,
    "w.latin": 1,
    "cost.tally": 3,
    "r.rhyme.remembrance": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.rhyme.remembrance", level: 2 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.thebarrowchildselegies",
    label: "The Barrowchild's Elegies",
    inherits: "_book",
  },
  {
    sky: 8,
    "period.solar": 1,
    "cost.tally": 4,
    "r.sacralimiae": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.sacralimiae", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.damascenetraditionsofthehouseoflethe",
    label: "Damascene Traditions of the House of Lethe",
    inherits: "_book",
  },
  {
    edge: 6,
    "period.curia": 1,
    "cost.tally": 2,
    "r.sickle.eclipse": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.sickle.eclipse", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.exorcismforgirls",
    label: "Exorcism for Girls",
    inherits: "_book",
  },
  {
    scale: 6,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.hill.hollow": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.hill.hollow", level: 1 },
    reading: { id: "music.savage", level: 1 },
    id: "t.singlefootsongs",
    label: "Singlefoot Songs",
    inherits: "_book",
  },
  {
    moon: 6,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.edictsmartial": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.edictsmartial", level: 1 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.anexorcistsfieldmanual",
    label: "An Exorcist's Field Manual",
    inherits: "_book",
  },
  {
    heart: 6,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.edictsinviolable": 1,
    soph: 6,
    "record.phonograph": 1,
    mastering: { id: "s.edictsinviolable", level: 1 },
    reading: { id: "mem.dreamt", level: 1 },
    id: "t.velletriinterviews",
    label: "Velletri Interviews",
    inherits: "_book",
  },
  {
    moon: 4,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.hill.hollow": 1,
    soph: 4,
    "record.phonograph": 1,
    mastering: { id: "s.hill.hollow", level: 1 },
    reading: { id: "mem.dreamt", level: 1 },
    id: "t.aninvestigationofafounderedcountry",
    label: "An Investigation of A Foundered Country",
    inherits: "_book",
  },
  {
    scale: 4,
    "period.nocturnal": 1,
    "w.mandaic": 1,
    "cost.tally": 1,
    "r.stonestories": 1,
    soph: 4,
    "record.phonograph": 1,
    mastering: { id: "s.stonestories", level: 1 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.recordingsfromthealthibanabyss",
    label: "Recordings from the Althiban Abyss",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    sky: 6,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.anbary.lapidary": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.anbary.lapidary", level: 1 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.evastreasury",
    label: "Eva's Treasury",
    inherits: "_book",
  },
  {
    knock: 4,
    "period.curia": 1,
    "cost.tally": 2,
    "r.glassblowing.vesselcrafting": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.glassblowing.vesselcrafting", level: 1 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.adviceoncontainment",
    label: "Advice on Containment",
    inherits: "_book",
  },
  {
    forge: 10,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.lockworks.clockworks": 1,
    soph: 10,
    film: 1,
    mastering: { id: "s.lockworks.clockworks", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.theadmonitoryautomataproject",
    label: "The Admonitory Automata Project",
    inherits: "_book",
  },
  {
    forge: 8,
    "period.curia": 1,
    "cost.tally": 2,
    "r.bells.brazieries": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.bells.brazieries", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.oldcoppernoseandthesoftermetal",
    label: "Old Coppernose and the Softer Metal",
    inherits: "_book",
  },
  {
    heart: 10,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.stitching.binding": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.stitching.binding", level: 2 },
    reading: { id: "mem.solace", level: 1 },
    id: "t.notesonbindings",
    label: "Notes on Bindings",
    inherits: "_book",
  },
  {
    scale: 8,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.furs.feathers": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.furs.feathers", level: 2 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.huntingjournalsofbryandewulf",
    label: "Hunting Journals of Bryan Dewulf",
    inherits: "_book",
  },
  {
    moon: 8,
    "period.curia": 1,
    "cost.tally": 2,
    "r.pearl.tide": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.pearl.tide", level: 2 },
    reading: { id: "mem.salt", level: 1 },
    id: "t.toapalelady",
    label: "To a Pale Lady",
    inherits: "_book",
  },
  {
    nectar: 8,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.insects.nectars": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.insects.nectars", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.thebeekeepersends",
    label: "The Bee-Keeper's Ends",
    inherits: "_book",
  },
  {
    heart: 8,
    "period.curia": 1,
    "w.greek": 1,
    "cost.tally": 2,
    "r.herbs.infusions": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.herbs.infusions", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.warmingdraughtstouplifttheheart",
    label: "Warming Draughts to Uplift the Heart",
    inherits: "_book",
  },
  {
    grail: 10,
    "period.solar": 1,
    "cost.tally": 4,
    "r.orchids.narcotics": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.orchids.narcotics", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.ajourneytothegrove",
    label: "A Journey to the Grove",
    inherits: "_book",
  },
  {
    scale: 8,
    "period.dawn": 1,
    "w.greek": 1,
    "cost.tally": 5,
    "r.serpents.venoms": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.serpents.venoms", level: 2 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.thehissingkey",
    label: "The Hissing Key",
    inherits: "_book",
  },
  {
    winter: 8,
    "period.curia": 1,
    "cost.tally": 2,
    "r.sights.sensations": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.sights.sensations", level: 2 },
    reading: { id: "bittersweet.certainty", level: 1 },
    id: "t.musgravessketches",
    label: "Musgrave's Sketches",
    inherits: "_book",
  },
  {
    forge: 8,
    "period.curia": 1,
    "cost.tally": 2,
    "r.spices.savours": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.spices.savours", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.ambrosial!",
    label: "Ambrosial!",
    inherits: "_book",
  },
  {
    winter: 8,
    "period.curia": 1,
    "cost.tally": 2,
    "r.rhyme.remembrance": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.rhyme.remembrance", level: 2 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.exercisesinthecontinuityofself",
    label: "Exercises in the Continuity of Self",
    inherits: "_book",
  },
  {
    forge: 8,
    "period.curia": 1,
    "cost.tally": 2,
    "r.meniscatereflections": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.meniscatereflections", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.theamalgamoftheredrose",
    label: "The Amalgam of the Red Rose",
    inherits: "_book",
  },
  {
    winter: 4,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.rhyme.remembrance": 1,
    soph: 4,
    codex: 1,
    mastering: { id: "s.rhyme.remembrance", level: 1 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.ladyevasrepose",
    label: "Lady Eva's Repose",
    inherits: "_book",
  },
  {
    winter: 8,
    "period.curia": 1,
    "cost.tally": 2,
    "r.putrefactions.calcinations": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.putrefactions.calcinations", level: 2 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.operationsofacertainfinality",
    label: "Operations of a Certain Finality",
    inherits: "_book",
  },
  {
    lantern: 10,
    "period.solar": 1,
    "cost.tally": 4,
    "r.purifications.exaltations": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.purifications.exaltations", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.thealloyofthewhiterose",
    label: "The Alloy of the White Rose",
    inherits: "_book",
  },
  {
    scale: 10,
    "period.solar": 1,
    "w.henavek": 1,
    "cost.tally": 4,
    "r.stonestories": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.stonestories", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.udrocashaas",
    label: "Ud Rocashaas",
    inherits: "_book",
    language: "s.henavek",
  },
  {
    lantern: 10,
    "period.solar": 1,
    "w.sabazine": 1,
    "cost.tally": 4,
    "r.sacrasolisinvicti": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.sacrasolisinvicti", level: 2 },
    reading: { id: "music.savage", level: 1 },
    id: "t.unhatchedhymns",
    label: "Unhatched Hymns",
    inherits: "_book",
    language: "s.sabazine",
  },
  {
    moth: 10,
    "period.solar": 1,
    "w.sabazine": 1,
    "cost.tally": 4,
    "r.sacralimiae": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.sacralimiae", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.anechoofsilence",
    label: "An Echo of Silence",
    inherits: "_book",
    language: "s.sabazine",
  },
  {
    moon: 10,
    "period.solar": 1,
    "w.vak": 1,
    "cost.tally": 4,
    "r.sickle.eclipse": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.sickle.eclipse", level: 2 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.observationsonthepeacockdoor",
    label: "Observations on the Peacock Door",
    inherits: "_book",
    language: "s.vak",
  },
  {
    edge: 10,
    "period.solar": 1,
    "w.hyksos": 1,
    "cost.tally": 4,
    "r.edictsmartial": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.edictsmartial", level: 2 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.theascendant",
    label: "The Ascendant",
    inherits: "_book",
    language: "s.hyksos",
  },
  {
    moon: 10,
    "period.curia": 1,
    "cost.tally": 2,
    "r.edictsinviolable": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.edictsinviolable", level: 2 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.thethreeandthethreekerishammanuscript",
    label: "The Three and the Three (Kerisham Manuscript)",
    inherits: "_book",
  },
  {
    moon: 14,
    "period.solar": 1,
    "cost.tally": 4,
    "r.edictsinviolable": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.edictsinviolable", level: 2 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.thethreeandthethreevaticanmanuscript",
    label: "The Three and the Three (Vatican Manuscript)",
    inherits: "_book",
  },
  {
    sky: 10,
    "period.solar": 1,
    "cost.tally": 4,
    "r.anbary.lapidary": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.anbary.lapidary", level: 2 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.theothereyeoftheserpent",
    label: "The Other Eye of the Serpent",
    inherits: "_book",
  },
  {
    knock: 10,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.glassblowing.vesselcrafting": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.glassblowing.vesselcrafting", level: 2 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.onimperfections",
    label: "On Imperfections",
    inherits: "_book",
  },
  {
    moon: 14,
    "period.solar": 1,
    "w.greek": 1,
    "cost.tally": 4,
    "r.sickle.eclipse": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.sickle.eclipse", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.thesecretcolours",
    label: "The Secret Colours",
    inherits: "_book",
  },
  {
    knock: 14,
    "period.baronial": 1,
    "w.fucine": 1,
    "cost.tally": 3,
    "r.edictsliminal": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.edictsliminal", level: 2 },
    reading: { id: "mem.dreamt", level: 1 },
    id: "t.deathsandtheirevasions",
    label: "Deaths and their Evasions",
    inherits: "_book",
    language: "s.fucine",
  },
  {
    knock: 16,
    "period.nocturnal": 1,
    "w.vak": 1,
    "cost.tally": 1,
    "r.preliminalmeter": 1,
    soph: 16,
    "record.phonograph": 1,
    mastering: { id: "s.preliminalmeter", level: 3 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.atowerfalls",
    label: "A Tower Falls",
    inherits: "_book",
    language: "s.vak",
  },
  {
    rose: 18,
    "period.nocturnal": 1,
    "w.vak": 1,
    "cost.tally": 1,
    "r.preliminalmeter": 1,
    soph: 18,
    "record.phonograph": 1,
    mastering: { id: "s.preliminalmeter", level: 3 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.atowerrises",
    label: "A Tower Rises",
    inherits: "_book",
    language: "s.vak",
  },
  {
    lantern: 12,
    "period.curia": 1,
    "cost.tally": 2,
    "r.inks.revelation": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.inks.revelation", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.thechandlerswish",
    label: "The Chandler's Wish",
    inherits: "_book",
  },
  {
    sky: 10,
    "period.curia": 1,
    "cost.tally": 2,
    "r.sacralimiae": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.sacralimiae", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.sunsetceliaandtheendofdays",
    label: "Sunset Celia and the End of Days",
    inherits: "_book",
  },
  {
    forge: 12,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.disciplines.thehammer": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.disciplines.thehammer", level: 2 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.thecarminepetalrevised",
    label: "The Carmine Petal: Revised",
    inherits: "_book",
  },
  {
    forge: 18,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.disciplines.thehammer": 1,
    soph: 18,
    codex: 1,
    mastering: { id: "s.disciplines.thehammer", level: 3 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.thecarminepetalunexpurgated",
    label: "The Carmine Petal: Unexpurgated",
    inherits: "_book",
  },
  {
    lantern: 8,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.inks.revelation": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.inks.revelation", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.letterstomysuccessor",
    label: "Letters To My Successor",
    inherits: "_book",
  },
  {
    moth: 10,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.inks.revelation": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.inks.revelation", level: 2 },
    reading: { id: "mem.intuition", level: 1 },
    id: "t.fromhistorytoeternity",
    label: "From History to Eternity",
    inherits: "_book",
  },
  {
    heart: 16,
    "period.solar": 1,
    "w.ericapaean": 1,
    "cost.tally": 4,
    "r.quenchings.quellings": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.quenchings.quellings", level: 3 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.nynscagesavignontext",
    label: "Nyn's Cages (Avignon Text)",
    inherits: "_book",
    language: "s.ericapaean",
  },
  {
    winter: 10,
    "period.solar": 1,
    "w.ericapaean": 1,
    "cost.tally": 4,
    "r.quenchings.quellings": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.quenchings.quellings", level: 2 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.nynscagesbrugestextilluminated",
    label: "Nyn's Cages (Bruges Text, Illuminated)",
    inherits: "_book",
    language: "s.ericapaean",
  },
  {
    moon: 8,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.edictsinviolable": 1,
    soph: 8,
    film: 1,
    mastering: { id: "s.edictsinviolable", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.experimentbeyondsight",
    label: "EXPERIMENT BEYOND SIGHT",
    inherits: "_book",
  },
  {
    grail: 6,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.resurgences.emergences": 1,
    soph: 6,
    film: 1,
    mastering: { id: "s.resurgences.emergences", level: 1 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.coloursintheliver",
    label: "COLOURS IN THE LIVER",
    inherits: "_book",
  },
  {
    edge: 8,
    "period.nocturnal": 1,
    "w.hyksos": 1,
    "cost.tally": 1,
    "r.disciplines.thescar": 1,
    soph: 8,
    film: 1,
    mastering: { id: "s.disciplines.thescar", level: 2 },
    reading: { id: "mem.revelation", level: 1 },
    id: "t.theopenhead",
    label: "THE OPEN HEAD",
    inherits: "_book",
    language: "s.hyksos",
  },
  {
    moon: 8,
    "period.baronial": 1,
    "w.killasimi": 1,
    "cost.tally": 3,
    "r.snowstories": 1,
    soph: 8,
    codex: 1,
    mastering: { id: "s.snowstories", level: 2 },
    reading: { id: "mem.salt", level: 1 },
    id: "t.thedeathsofthemoon",
    label: "The Deaths of the Moon",
    inherits: "_book",
    language: "s.killasimi",
  },
  {
    moon: 10,
    "period.baronial": 1,
    "cost.tally": 3,
    "r.hill.hollow": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.hill.hollow", level: 2 },
    reading: { id: "mem.salt", level: 1 },
    id: "t.thequeensturn",
    label: "The Queen's Turn",
    inherits: "_book",
  },
  {
    forge: 10,
    "period.dawn": 1,
    "w.mandaic": 1,
    "cost.tally": 5,
    "r.disciplines.thehammer": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.disciplines.thehammer", level: 2 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.skinofsilver",
    label: "Skin of Silver",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    grail: 12,
    "period.dawn": 1,
    "w.killasimi": 1,
    "cost.tally": 5,
    "r.tridesmahiera": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.tridesmahiera", level: 2 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.onethousandthreads",
    label: "One Thousand Threads",
    inherits: "_book",
    language: "s.killasimi",
  },
  {
    moth: 6,
    "period.baronial": 1,
    "w.sabazine": 1,
    "cost.tally": 3,
    "r.sacralimiae": 1,
    soph: 6,
    codex: 1,
    mastering: { id: "s.sacralimiae", level: 1 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.thecarbonekschism",
    label: "The Carbonek Schism",
    inherits: "_book",
    language: "s.sabazine",
  },
  {
    edge: 18,
    "period.curia": 1,
    "w.killasimi": 1,
    "cost.tally": 2,
    "r.disciplines.thescar": 1,
    soph: 18,
    codex: 1,
    mastering: { id: "s.disciplines.thescar", level: 3 },
    reading: { id: "mem.regret", level: 1 },
    id: "t.thewoundwounds",
    label: "The Wound-Wounds",
    inherits: "_book",
    language: "s.killasimi",
  },
  {
    forge: 10,
    "period.nocturnal": 1,
    "cost.tally": 1,
    "r.sights.sensations": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.sights.sensations", level: 2 },
    reading: { id: "bittersweet.certainty", level: 1 },
    id: "t.glimmerings",
    label: "Glimmerings",
    inherits: "_book",
  },
  {
    grail: 10,
    "period.dawn": 1,
    "w.killasimi": 1,
    "cost.tally": 5,
    "r.tridesmahiera": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.tridesmahiera", level: 2 },
    reading: { id: "mem.satisfaction", level: 1 },
    id: "t.thewonderfulshape",
    label: "The Wonderful Shape",
    inherits: "_book",
    language: "s.killasimi",
  },
  {
    knock: 12,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 5,
    "r.door.wall": 1,
    soph: 12,
    codex: 1,
    mastering: { id: "s.door.wall", level: 2 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.thegrandpassageofthehours",
    label: "The Grand Passage of the Hours",
    inherits: "_book",
    language: "s.vak",
  },
  {
    forge: 16,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 5,
    "r.door.wall": 1,
    soph: 16,
    codex: 1,
    mastering: { id: "s.door.wall", level: 3 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.themessengerawaitingherdestination",
    label: "The Messenger Awaiting Her Destination",
    inherits: "_book",
    language: "s.vak",
  },
  {
    knock: 18,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 5,
    "r.door.wall": 1,
    soph: 18,
    codex: 1,
    mastering: { id: "s.door.wall", level: 3 },
    reading: { id: "mem.pattern", level: 1 },
    id: "t.theroadtojanus",
    label: "The Road to Janus",
    inherits: "_book",
    language: "s.vak",
  },
  {
    nectar: 10,
    "period.dawn": 1,
    "w.cracktrack": 1,
    "cost.tally": 5,
    "r.rites.theroots": 1,
    soph: 10,
    codex: 1,
    mastering: { id: "s.rites.theroots", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.greenjaspertablet",
    label: "Green Jasper Tablet",
    inherits: "_book",
    language: "s.cracktrack",
  },
  {
    moth: 14,
    "period.dawn": 1,
    "w.cracktrack": 1,
    "cost.tally": 5,
    "r.rites.theroots": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.rites.theroots", level: 2 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.whitejadetablet",
    label: "White Jade Tablet",
    inherits: "_book",
    language: "s.cracktrack",
  },
  {
    knock: 21,
    "period.dawn": 1,
    "w.vak": 1,
    "cost.tally": 5,
    "r.preliminalmeter": 1,
    soph: 21,
    codex: 1,
    infinitereadable: 1,
    mastering: { id: "s.preliminalmeter", level: 3 },
    reading: { id: "confounding.parable", level: 1 },
    id: "t.xenodiceneodes",
    label: "Xenodicene Odes",
    inherits: "_book",
    language: "s.vak",
  },
  {
    lantern: 21,
    "period.solar": 1,
    "w.ericapaean": 1,
    "cost.tally": 4,
    "r.auroralcontemplations": 1,
    soph: 21,
    codex: 1,
    infinitereadable: 1,
    mastering: { id: "s.auroralcontemplations", level: 3 },
    reading: { id: "mem.contradiction", level: 1 },
    id: "t.quirinicmeditations",
    label: "Quirinic Meditations",
    inherits: "_book",
    language: "s.ericapaean",
  },
  {
    grail: 21,
    "period.baronial": 1,
    "w.killasimi": 1,
    "cost.tally": 3,
    "r.pentiments.precursors": 1,
    soph: 21,
    codex: 1,
    infinitereadable: 1,
    mastering: { id: "s.pentiments.precursors", level: 3 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.medusancommentaries",
    label: "Medusan Commentaries",
    inherits: "_book",
    language: "s.killasimi",
  },
  {
    scale: 21,
    "period.curia": 1,
    "w.cracktrack": 1,
    "cost.tally": 2,
    "r.stonestories": 1,
    soph: 21,
    codex: 1,
    infinitereadable: 1,
    mastering: { id: "s.stonestories", level: 3 },
    reading: { id: "mem.impulse", level: 1 },
    id: "t.echidnalia",
    label: "Echidnalia",
    inherits: "_book",
    language: "s.cracktrack",
  },
  {
    winter: 21,
    "period.nocturnal": 1,
    "w.sabazine": 1,
    "cost.tally": 1,
    "r.sights.sensations": 1,
    soph: 21,
    codex: 1,
    infinitereadable: 1,
    mastering: { id: "s.sights.sensations", level: 3 },
    reading: { id: "mem.hindsight", level: 1 },
    id: "t.naeniansketches",
    label: "Naenian Sketches",
    inherits: "_book",
    language: "s.sabazine",
  },
  {
    moth: 21,
    "period.baronial": 1,
    "w.mandaic": 1,
    "cost.tally": 2,
    "r.transformations.liberations": 1,
    soph: 21,
    codex: 1,
    infinitereadable: 1,
    mastering: { id: "s.transformations.liberations", level: 3 },
    reading: { id: "mem.foresight", level: 1 },
    id: "t.plantagenetmysteries",
    label: "Plantagenet Mysteries",
    inherits: "_book",
    language: "s.mandaic",
  },
  {
    edge: 14,
    "period.nocturnal": 1,
    "w.hyksos": 1,
    "cost.tally": 4,
    "r.sharps": 1,
    soph: 14,
    codex: 1,
    mastering: { id: "s.sharps", level: 2 },
    reading: { id: "mem.fear", level: 1 },
    id: "t.journalofsirdavidgreene1903",
    label: "Journal of Sir David Greene, 1903",
    inherits: "_book",
    language: "s.hyksos",
  },
] as any as Book[];
